import { render, staticRenderFns } from "./UploadSimple.vue?vue&type=template&id=4a024711&scoped=true"
import script from "./UploadSimple.vue?vue&type=script&lang=js"
export * from "./UploadSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a024711",
  null
  
)

export default component.exports